/**
 * oms micro front end sdk
 */

import Zntry from '@zn-collect/monitor';
import { microAppList, microAppMark } from '../../config/micro.config';
import mainBus from './eventBus';

const action = '';

// 获取入口
const getEntry = (item) => {
  const startStr = process.env.NODE_ENV === 'development' ? `//localhost:${item.port}` : microAppMark;
  return `${startStr}${item.activeRule}`;
};

const getMicroAppList = () => microAppList.map((app) => ({
  ...app,
  entry: getEntry(app),
  container: `#${app.name}`,
  props: {
    _app: app,
    _setGlobalData: mainBus,
    _zntry: Zntry,
    // router vuex
  },
}));

export {
  getMicroAppList,
  action,
};
